import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar"]

  connect() {
    this.open = false
  }

  toggle() {
    this.open = !this.open
    this.sidebarTarget.toggleAttribute("data-open", this.open)
    document.body.classList.toggle("overflow-hidden", this.open)

    if (this.open) {
      this.overlay = document.createElement("div")
      this.overlay.className = "fixed inset-0 bg-black/30 z-20 lg:hidden"
      this.overlay.addEventListener("click", () => this.close())
      document.body.appendChild(this.overlay)
    } else {
      this.overlay?.remove()
    }
  }

  close() {
    if (!this.open) return
    this.open = false
    this.sidebarTarget.removeAttribute("data-open")
    document.body.classList.remove("overflow-hidden")
    this.overlay?.remove()
  }
}
